import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '@/hooks/use-auth'
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/login')({
  component: RouteComponent,
})

function RouteComponent() {
  const { login, isLoading } = useAuth();

  return (
    <div className="flex items-center justify-center h-full">
      <Card className="w-[350px]">
        <CardHeader>
          <CardTitle className='text-2xl text-center'>Shamba ODK</CardTitle>
          <CardDescription className='text-center'>
            Data Collection in the Field
          </CardDescription>
        </CardHeader>
        <CardFooter>
          <Button
            className="w-full"
            onClick={login}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Login with ERP"}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
